<template>
  <div class="thank-you-wrap">
    <main class="screen" role="main">

      <div class="hero">

        <div class="checkmark-circle" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M5 12 L10 17 L19 7"/>
          </svg>
        </div>

        <h1 class="title">Vielen Dank!</h1>

        <p class="message">
          Du hast einen Beitrag zur Forschung an der BFH geleistet. Jede Antwort
          hilft, gesunde Ernährung in der Schweiz besser zu verstehen.
        </p>

        <div class="stat-card">
          <p class="stat-label">Du bist Teilnehmer/in Nummer</p>
          <p class="stat-value"><strong>{{ participantNumber }}</strong></p>
        </div>

      </div>

      <div class="footer">
        <button type="button" class="share-button" @click="share">
          Quiz mit Freunden teilen
        </button>
        <button type="button" class="secondary-button" @click="goToBfh">
          Zur BFH Webseite
        </button>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  data() {
    return {
      participantNumber: "1'247",
    };
  },
  methods: {
    async share() {
      const shareData = {
        title: 'Swiss Eating Quiz',
        text: 'Wie ernährst du dich? Mach den 8-Minuten-Quiz der BFH.',
        url: window.location.origin,
      };
      if (navigator.share) {
        try { await navigator.share(shareData); } catch (_) { /* user cancelled */ }
      }
    },
    goToBfh() {
      window.open('https://www.bfh.ch/', '_blank', 'noopener');
    },
  },
};
</script>

<style scoped>
.thank-you-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.thank-you-wrap *,
.thank-you-wrap *::before,
.thank-you-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 2rem 1.5rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.checkmark-circle {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: var(--color-accent-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  animation: scaleIn 0.4s ease-out;
}

.checkmark-circle svg {
  width: 44px;
  height: 44px;
  stroke: var(--color-accent);
  stroke-width: 3;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.checkmark-circle svg path {
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  animation: drawCheck 0.5s 0.3s ease-out forwards;
}

@keyframes scaleIn {
  0% { transform: scale(0); opacity: 0; }
  60% { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes drawCheck {
  to { stroke-dashoffset: 0; }
}

.title {
  font-size: 28px;
  font-weight: 500;
  margin: 0 0 12px;
  line-height: 1.2;
  color: var(--color-text-primary);
}

.message {
  font-size: 16px;
  color: var(--color-text-secondary);
  margin: 0 auto 1.5rem;
  line-height: 1.6;
  max-width: 320px;
}

.stat-card {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 16px 20px;
  margin: 0 auto 0.5rem;
  width: 100%;
  max-width: 320px;
}

.stat-label {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 4px;
}

.stat-value {
  font-size: 18px;
  font-weight: 500;
  color: var(--color-text-primary);
  margin: 0;
}

.stat-value strong {
  color: var(--color-accent);
  font-weight: 500;
}

.footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 1rem;
}

.share-button {
  width: 100%;
  padding: 14px;
  background: var(--color-accent);
  color: white;
  border: 0.5px solid var(--color-accent);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: pointer;
}

.share-button:hover {
  opacity: 0.9;
}

.secondary-button {
  width: 100%;
  padding: 14px;
  background: transparent;
  color: var(--color-text-secondary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
}

.secondary-button:hover {
  background: var(--color-bg-muted);
}
</style>
